import { useFormik } from "formik"
import React from "react"
import { Form, FormFeedback, Input, Label } from "reactstrap"
import * as Yup from "yup"

const VALIDATION_TYPES = [
  { label: "Mandatory", value: "mandatory" },
]

const generateKey = () => Math.random().toString(36).slice(2, 8)

const ValidationForm = props => {
  const valData = props.valData || null
  const vars = props.vars || []

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      var: valData?.var || "",
      valdn_type: valData?.valdn_type || "mandatory",
      message: valData?.message || "",
    },
    validationSchema: Yup.object({
      var: Yup.string().required("Please select a variable"),
      valdn_type: Yup.string().required("Please select a validation type"),
      message: Yup.string().required("Please enter a message"),
    }),
    onSubmit: values => {
      props.onSave({
        var: values.var,
        valdn_type: values.valdn_type,
        message: values.message,
        key: valData?.key || generateKey(),
      })
    },
  })

  return (
    <>
      <div className="modal-header">
        <h5 className="modal-title mt-0">
          {props.isNew ? "Add New Validation" : "Update Validation"}
        </h5>
      </div>
      <Form className="form-horizontal" id="addValForm">
        <div className="modal-body">
          <div className="mb-3">
            <Label className="form-label" htmlFor="valVar">
              Variable <span className="text-danger">*</span>
            </Label>
            <Input
              id="valVar"
              name="var"
              type="select"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.var || ""}
              invalid={!!(validation.touched.var && validation.errors.var)}
            >
              <option value="">Select variable</option>
              {vars.map(v => (
                <option key={v.name} value={v.name}>{v.name}</option>
              ))}
            </Input>
            {validation.touched.var && validation.errors.var && (
              <FormFeedback type="invalid">{validation.errors.var}</FormFeedback>
            )}
          </div>

          <div className="mb-3">
            <Label className="form-label" htmlFor="valType">Validation Type</Label>
            <Input
              id="valType"
              name="valdn_type"
              type="select"
              onChange={validation.handleChange}
              value={validation.values.valdn_type}
            >
              {VALIDATION_TYPES.map(t => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </Input>
          </div>

          <div className="mb-3">
            <Label className="form-label" htmlFor="valMessage">
              Message <span className="text-danger">*</span>
            </Label>
            <Input
              id="valMessage"
              name="message"
              type="textarea"
              rows={3}
              placeholder="Error message shown when this validation fails"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.message || ""}
              invalid={!!(validation.touched.message && validation.errors.message)}
            />
            {validation.touched.message && validation.errors.message && (
              <FormFeedback type="invalid">{validation.errors.message}</FormFeedback>
            )}
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => validation.handleSubmit()}
          >
            Save
          </button>{" "}
          <button type="button" className="btn btn-secondary" onClick={props.closeModal}>
            Cancel
          </button>
        </div>
      </Form>
    </>
  )
}

export default ValidationForm
